(function() {
  'use strict';
  angular.module('claims')
    .controller('claimSummaryController', ['$scope', '$rootScope','$log','$state', '$stateParams','$translate','Claims', 'historyService', '$transitions', 'printService', '$window',  
      function($scope,$rootScope, $log, $state, $stateParams,$translate,Claims, historyService, $transitions, printService,$window) {
        var vm = this;
        vm.claimId = $stateParams.claimId;
        vm.returnFlag = true;
        
        $transitions.onEnter({}, function(transition) {
          if(transition.from().name == 'userHistory'){
        	$rootScope.rootFlag = false;
  	      }else{
  	    	$rootScope.rootFlag = true; 
  	    	vm.returnFlag = true;
  	      }
  		});
        
        $transitions.onExit({}, function(transition) {
            $rootScope.rootFlag = true;
            vm.returnFlag = true;
    	});
        
        vm.$onInit = function() {
          vm.claimHeaderData = Claims.getClaimHeader({claimId: vm.claimId}).$promise;
          vm.claimLinesData = Claims.getClaimLines({claimId: vm.claimId}).$promise;
          vm.claimPaymentsData = Claims.getClaimPayments({claimId: vm.claimId}).$promise;
          if($rootScope.rootFlag != null){
            vm.returnFlag = $rootScope.rootFlag;
            $rootScope.rootFlag = true;
          }
          vm.claimHeaderData.then((response) => {
            if(response.data){
            	if(response.data && response.data.claims.length){
                    vm.claimHeaderInfo = response.data.claims[0];
                  }
              _.each(response.data.claims, (claim) => {
                var index = _.findIndex(historyService.claimHistories, function(history) {
                  return history.eventData.claimId == vm.claimId;
                });
                if(index >= 0) {
                  historyService.claimHistories.splice(index, 1);
                }
                historyService.claimHistories.splice(0,0,{eventData:{
                  name:claim.patientName.toUpperCase(),
                  claimId: claim.claimId,
                  birthDate: claim.dateOfService,
                  eventName: "Claim Detail"}});
                if(historyService.claimHistories.length > historyService.maxSize) {
                  historyService.claimHistories.splice(historyService.maxSize,1);
                }
              });
            }
          }
          );
          
          vm.claimLinesData.then((response) => {
              if(response.data){
            	  vm.claimLinesInfo = response.data.lineDetail ;
              }
            });
          
          vm.claimPaymentsData.then((response) => {
              if(response.data){
            	  vm.claimPaymentsInfo = response.data.payments ;
              }
            });
          
          
        };

        $scope.doTheBack = function() {
        	history.go(-1);
        };
        
        vm.print = function() {
            vm.printing = true;
            printService.print({claimHeaderInfo: vm.claimHeaderInfo, claimLinesInfo: vm.claimLinesInfo, claimPaymentsInfo: vm.claimPaymentsInfo, printType: "claims"},function(pdfdata) {
	                vm.printing = false;
	                if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
	            	    $window.navigator.msSaveOrOpenBlob(pdfdata.document);
	            	}else {
	            	    var printUrl = URL.createObjectURL(pdfdata.document);
	            	    $window.open(printUrl, 'dnoa');
	            	}
                },function (error) {
                    vm.printing = false;
                    $scope.dnConfirmationMessage.$show('Error while sending document to DNOA.', 'warning');
            });
        }

      }]);
})();
